module.exports = "<div class=calendar-main-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.main.html
// module id = 4928
// module chunks = 50